import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Typography,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import {
  CreateSupportTicketMetaRouting,
  Resource,
  User,
} from "../../../app/backendTypes";
import {
  useCreateSupportTicketMeta,
  usePendingSupportTask,
} from "../../../app/hooks";
import Loading from "../Loading";
import Error from "../Error";
import PendingAction from "../tools/PendingAction";
import { useState } from "react";
import SupportDialog from "./SupportDialog";
import ExpandMore from "../ExpandMore";

export default function SupportCard(props: { resource: Resource; user: User }) {
  const { resource, user } = props;

  const [expanded, setExpanded] = useState(false);

  const { meta, loading, error } = useCreateSupportTicketMeta(
    resource.kind === "Tool" ? resource.inner.id : resource.inner.name
  );
  const {
    task: pendingTask,
    loading: pendingLoading,
    error: pendingError,
    reload: pendingReload,
  } = usePendingSupportTask(resource, user.employee.id);

  const [open, setOpen] = useState(false);
  const [routing, setRouting] = useState<CreateSupportTicketMetaRouting | null>(
    null
  );

  let element = <></>;
  if (loading || pendingLoading) element = <Loading />;
  else if (error !== undefined) element = <Error error={error} />;
  else if (pendingError !== undefined) element = <Error error={pendingError} />;
  else if (pendingTask !== null)
    element = (
      <>
        <Typography>
          You have a pending support task for this resource
        </Typography>

        <br />

        <PendingAction
          task={pendingTask}
          callback={pendingReload}
          onCompleted={pendingReload}
        />
      </>
    );
  else if (meta !== null)
    element = (
      <>
        <Typography>Pick a case that matches your needs</Typography>

        <br />

        <Box sx={{ display: "flex", gap: 2 }}>
          {meta.routings.map((r, i) => (
            <Button
              key={i}
              color="secondary"
              variant="outlined"
              onClick={() => {
                setRouting(r);
                setOpen(true);
              }}
            >
              {r.name.split("-")[0]}
            </Button>
          ))}
        </Box>
      </>
    );

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <Card sx={{ width: "100%", maxWidth: "sm" }}>
        <CardHeader
          subheader="Need help with this resource?"
          action={
            <ExpandMore expand={expanded} onClick={handleExpandClick}>
              <ExpandMoreIcon />
            </ExpandMore>
          }
        />
        <Collapse in={expanded} timeout="auto">
          <CardContent>{element}</CardContent>
        </Collapse>
      </Card>

      {meta !== null && routing !== null && (
        <SupportDialog
          open={open}
          setOpen={setOpen}
          routing={routing}
          offering={meta.offering}
          service={meta.service}
          resource={resource}
          user={user}
          callback={pendingReload}
        />
      )}
    </>
  );
}
